export default __webpack_public_path__ + "images/c88ac74c91f721f5c9ddbfab4c50e57e.png";